import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

console.log("V3 - index.js loaded");

// Plain JS features
import { searchBox } from "./scripts/search/SearchBox";
import PopulateFields from "./scripts/misc-classes/PopulateEmail";
import ProviderSearch from "./scripts/misc-classes/ProviderSearch";

// The SearchResults component
import SearchResults from "./scripts/search-results/Index";

// Other components, e.g., Dashboard
import Dashboard from "./scripts/Dashboard";

// 1) Plain JS stuff
const searchFeature = document.getElementById("ca-search-bar-v3");
if (searchFeature) {
  searchBox();
}

const regFormScripts = document.getElementById("provider-search-v3");
if (regFormScripts) {
  const provSearch = new ProviderSearch();
  const populateEmail = new PopulateFields();
}

// 2) Conditionally mount SearchResults
const searchRenderEl = document.getElementById("ca-search-render");
if (searchRenderEl) {
  ReactDOM.render(<SearchResults />, searchRenderEl);
}

// 3) Conditionally mount Dashboard
const dashBoardFeature = document.getElementById("provider-dashboard-v3");
if (dashBoardFeature) {
  const provID = dashBoardFeature.getAttribute("data-provID");
  const userRole = dashBoardFeature.getAttribute("data-userID");
  const provRole = dashBoardFeature.getAttribute("data-provRole");

  ReactDOM.render(<Dashboard provID={provID} userRole={userRole} provRole={provRole} />, dashBoardFeature);
}
